import { apiWithBody, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_EHRInstanceKBVersion, DBDef_EHRInstanceKBVersion } from '@app/org-shared';
export const dispatch_onEHRInstanceKBVersionsUpdated = new ThunderDispatcherV3('__onEHRInstanceKBVersionsUpdated');
export class ModuleFE_EHRInstanceKBVersion_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_EHRInstanceKBVersion, dispatch_onEHRInstanceKBVersionsUpdated);
        this._v1 = {
            'create-item': apiWithBody(ApiDef_EHRInstanceKBVersion._v1['create-item']),
        };
    }
}
export const ModuleFE_EHRInstanceKBVersion = new ModuleFE_EHRInstanceKBVersion_Class();
//# sourceMappingURL=ModuleFE_EHRInstanceKBVersion.js.map